module.exports = {"responseCodeToFriendlyMessageMap":{"auth/user-not-found":"Wrong email/password combination","auth/user-disabled":"This user is disabled","auth/invalid-email":"Invalid email format","auth/email-already-in-use":"User with this email exists","auth/operation-not-allowed":"System err: cannot perform","auth/weak-password":"Choose a stronger password","auth/wrong-password":"Wrong email/password combination","auth/web-storage-unsupported":"Google blocked by your browser settings"}}


//////////////////
// WEBPACK FOOTER
// ./src/third-party/firebase/config/firebaseConfig.json
// module id = 5q+d
// module chunks = 1